export default __webpack_public_path__ + "static/media/vanilla.79fe2c23.jpg";